import { render, staticRenderFns } from "./class_modal.vue?vue&type=template&id=1263ed19&"
import script from "./class_modal.vue?vue&type=script&lang=js&"
export * from "./class_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports